import React, { useEffect, useState, useImperativeHandle } from "react";
import { Loading } from "@xp-design/mobile";
import { trottingHorseLamp } from "@/api/configPage.ts";
import { forwardRef } from "react";

// const NameList: React.FC<{ activityCode: string; isNeedBack: boolean; isReload: boolean; }> = (
//   props, ref
// ) => {
const NameList = forwardRef<
  HTMLLIElement,
  { activityCode: string; isNeedBack: boolean }
>((props, ref) => {
  const { activityCode, isNeedBack = true } = props;

  const [trottingList, setTrottingList] = useState<any>([]); // 走马灯列表
  const [trottingIndex, setTrottingIndex] = useState<any>(0); // 走马灯索引
  // 获取中奖走马灯
  const getTrottingList = async (activityCode) => {
    try {
      Loading.show("加载中...");
      const res = await trottingHorseLamp({
        activityCode,
      });
      if (res.code === 200) {
        setTrottingList(res.data);
        // setTrottingList([
        //   {
        //     "productName": "充电卡xxxxxxxx",
        //     "userName": "吴亦凡"
        //   },
        //   {
        //     "productName": "按摩椅",
        //     "userName": "李易峰"
        //   }
        // ])
        // 5分钟（三百秒）请求一次
        setTimeout(() => {
          getTrottingList(activityCode);
        }, 300000);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      Loading.hide();
    }
  };
  // 暴露方法到 ref
  React.useImperativeHandle(ref, () => ({
    refresh: getTrottingList,
  }));

  useEffect(() => {
    if (trottingList.length) {
      // 十秒切换一次走马灯文字
      setTimeout(() => {
        if (trottingIndex === trottingList.length - 1) {
          setTrottingIndex(0);
        } else {
          setTrottingIndex(trottingIndex + 1);
        }
      }, 5000);
    }
  }, [trottingList, trottingIndex]);

  useEffect(() => {
    getTrottingList(activityCode);
  }, []);

  return trottingList.length > 0 ? (
    <div className={isNeedBack ? "scrolling-text" : "scrolling-text2"}>
      <div
        className="text-content"
        style={{
          animation: `marquee ${trottingList.length * 6}s linear infinite`,
        }}
      >
        {trottingList.map((e, index) => {
          return (
            <span
              key={index}
              className="text-item"
            >{`恭喜用户${e.userName}获得${e.productName}`}</span>
          );
        })}
      </div>
    </div>
  ) : null;
});

export default NameList;
